import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionContentItemWireframe from './VeltTranscriptionContentItemWireframe/VeltTranscriptionContentItemWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltTranscriptionContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-content-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionContentWireframe.Item = VeltTranscriptionContentItemWireframe;
export default VeltTranscriptionContentWireframe;
